const baseRoute = '/driver-tipping'

export const DriverTippingAreaRoutes = {
  route: baseRoute,
  List: { route: baseRoute },
  Show: {
    route: `${baseRoute}/:periodId`,
  },
}
